import React from 'react';
import { ProjectsListing } from '@components/projectsListing/projectsListing';
import { apiUrls } from '@constants/apiurls';
import projects from '@redux/modules/projects';
import styles from '@components/dashboard/dashboard.module.scss';
import { routesPath } from '@constants/routesPath';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { ClientHeader } from '@components/clientHeader/clientHeader';
import clients from '@redux/modules/clients';
import { Spinner } from '@components/loader/loader';

export const ProjectsListingContainer = () => {
  const navigate = useNavigate();
  const params = useParams();

  const {
    data: clientData,
    error: clientError,
    isFetching: clientLoading,
  } = clients.list().useClientsdetailQuery(
    { params: { id: params.clientId }, extendedPath: apiUrls.getClientDetail() },
    {
      skip: !params.clientId,
    },
  );
  const onAdd = () => {
    navigate(routesPath.addProjects(params.clientId));
  };
  return (
    <div className={styles.dashboardWrappper}>
      {clientLoading ? (
        <div className="text-center ">
          <Spinner height="100vh" width="100" />
        </div>
      ) : (
        <ProjectsListing
          clients={clientData?.data}
          projects={clientData?.data.projects}
          onProjectAdd={onAdd}
        />
      )}
    </div>
  );
};
